// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#hr-content #form-filter-request .filter-input-field.select {
    position: relative;
    margin-top: 15px;
}

#hr-content .btn-select-all [type="checkbox"].filled-in:not(:checked)+span:not(.lever):after {
    height: 17px;
    width: 17px;
    top: 2px;
}

#hr-content .btn-select-all [type="checkbox"].filled-in:checked+span:not(.lever):after {
    top: 3px;
    width: 16px;
    height: 16px;
}

#hr-content .btn-select-all [type="checkbox"].filled-in:checked+span:not(.lever):before {
    top: 0px;
    left: 0px;
    width: 6px;
    height: 13px;
}

#hr-content .btn-select-all [type="checkbox"]+span:not(.lever) {
    padding-left: 22px; 
}

#hr-content .btn-select-all [type="checkbox"]+span:not(.lever) {
    font-size: 12px !important;
}

#hr-content .btn-select-all {
    position: absolute;
    top: -14px;
    left: 5px;
    /*right: 5px;*/
}

.inner-container th .detail {
    color: red;
    font-size: 12px;
    text-transform: none;
    font-weight: normal;
    line-height: 14px;
}
.red-text {
    color: red !important;
}
.inner-container #table-total {
    height: 40px;
    margin-bottom: 10px;
}
#content-assign_days .title{
    text-align: right;
    line-height: 30px;
}
#content-assign_days{
    margin-top: 25px;
}
.inner-container .dropdown-content li>a, .inner-container .dropdown-content li>span {
    font-size: 14px;
    text-transform: none;
    padding: 10px 12px;
    font-weight: normal;
}
.inner-container .th-bulk-action .dropdown-trigger {
    font-size: 12px !important;
    padding: 0 5px !important;
}
.inner-container .th-bulk-action {
    position: relative;
}
.inner-container .inp-assign-disable-expired {
    border: 2px solid #bf4848 !important;
    height: 30px !important;
    margin-bottom: 0px !important;
    padding-bottom: 0px !important;
    text-align: center;
    color: #9e9e9e;
    background-color: #eee !important;
    font-size: 14px !important;
    max-width: 60px;
    min-width: 60px;
}
.inner-container .inp-assign-disable {
    border: 2px solid #d1d1d1 !important;
    height: 30px !important;
    margin-bottom: 0px !important;
    padding-bottom: 0px !important;
    text-align: center;
    color: #9e9e9e;
    background-color: #eee !important;
    font-size: 14px !important;
    max-width: 60px;
    min-width: 60px;
}
.inner-container .inp-assign, .modal-inp-assign {
    border: 2px solid #2b988e !important;
    height: 30px !important;
    margin-bottom: 0px !important;
    padding-bottom: 0px !important;
    text-align: center;
    font-size: 14px !important;
    max-width: 60px;
    min-width: 60px;
}
.inner-container th {
    font-size: 12px;
}
.inner-container .btn-delete, .inner-container .btn-check {
    padding-right: 8px;
    padding-left: 8px;
}
.inner-container .btn-view-calendar .material-icons {
    color: #000;
    margin-left: 8px;
    font-size: 21px;
    line-height: 38px;
}
.inner-container .btn-view-calendar {
    float: right;
    margin-left: 5px;
    font-size: 13px;
    text-transform: none;
    padding-left: 5px;
    padding-right: 5px;
}
.inner-container .btn-export .material-icons {
    color: #000;
    margin-left: 8px;
    font-size: 20px;
    line-height: 38px;
}
.inner-container .btn-export {
    float: right;
    margin-left: 5px;
    font-size: 13px;
    text-transform: none;
    padding-left: 5px;
    padding-right: 5px;
}
.inner-container .image-circle i {
    font-size: 36px;
    margin-left: auto;
}
.inner-container .th-view, .inner-container .th-change {
    max-width: 70px;
}
.inner-container .th-status {
    max-width: 100px;
    min-width: 100px;
}
.inner-container #main-content {
    padding-top: 0px;
    position: relative;
}
.inner-container #top-content {
    border-bottom: 0px dashed #ece7e7;
    margin-bottom: 25px;
}
.inner-container #main-btn {
    /*border-bottom: 2px dashed #ece7e7;
    padding-bottom: 18px;*/
    position: absolute;
    top: -90px;
    right: 25px;
}
#table-leave-summary .text-center {
    text-align: center;
}
#table-leave-summary .text-left {
    text-align: left;
}
.inner-container .td-photo {
    height: 65px;
    position: relative;
    min-width: 56px;
}
.inner-container .image-circle {
    width: 56px;
    height: 56px;
    position: absolute;
    top: 4px;
    left: 50%;
    margin-left: -28px;
}
.inner-container .select-helper-text {
    margin-top: -10px;
}
.inner-container #form-filter-request .filter-inputs.row{
    border-bottom: 2px dashed #ece7e7;
}
.inner-container #form-filter-request {
    padding: 0 20px;
}
.inner-container #btn-select-limit-row .input-field {
    margin-bottom: 0px;
}
.inner-container .input-field {
    margin-top: 0px;
    margin-bottom: 1rem;
}
.inner-container .select-wrapper .caret {
    fill: #27766f;
}
.inner-container .filter-input-field.select .col {
    border: 2px solid #2b988e;
    border-radius: 11px;
}
.inner-container .dropdown-content li {
    min-height: auto;
}
.inner-container .dropdown-content li>a, .inner-container .dropdown-content li>span {
    line-height: 20px;
    padding: 10px 16px;
}
.inner-container .input-field>label, .inner-container .input-field>input[type=date]:not(.browser-default)+label {
    color: #27766f;
}
.inner-container input[type=text]:not(.browser-default):not(.inp-assign):not(.inp-assign-disable):not(.select-dropdown):not(.inp-assign-disable-expired), .inner-container input[type=date]:not(.browser-default), input[type=text]:not(.modal-inp-assign){
    font-size: 14px;
    border-bottom: 2px solid #2b988e;
    color: #26a69a;
}
.inner-container [type="checkbox"]+span:not(.lever) {
    height: 22px;
    line-height: 22px;
    font-size: 14px;
}
.inner-container .select-wrapper input.select-dropdown {
    font-size: 14px;
    border-bottom: 0px solid red !important;
    margin-bottom: 0px;
    color: #26a69a;
}
.inner-container .grid-container, .inner-container .filter-inputs {
    display: grid;
    grid-template-columns: auto auto auto auto;
    grid-gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/HrAssign/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,iCAAiC;IACjC,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,iCAAiC;IACjC,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;AACA;IACI;0BACsB;IACtB,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,gCAAgC;IAChC,cAAc;AAClB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,eAAe;IACf,uCAAuC;IACvC,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,aAAa;IACb,0CAA0C;IAC1C,cAAc;AAClB","sourcesContent":["#hr-content #form-filter-request .filter-input-field.select {\r\n    position: relative;\r\n    margin-top: 15px;\r\n}\r\n\r\n#hr-content .btn-select-all [type=\"checkbox\"].filled-in:not(:checked)+span:not(.lever):after {\r\n    height: 17px;\r\n    width: 17px;\r\n    top: 2px;\r\n}\r\n\r\n#hr-content .btn-select-all [type=\"checkbox\"].filled-in:checked+span:not(.lever):after {\r\n    top: 3px;\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n\r\n#hr-content .btn-select-all [type=\"checkbox\"].filled-in:checked+span:not(.lever):before {\r\n    top: 0px;\r\n    left: 0px;\r\n    width: 6px;\r\n    height: 13px;\r\n}\r\n\r\n#hr-content .btn-select-all [type=\"checkbox\"]+span:not(.lever) {\r\n    padding-left: 22px; \r\n}\r\n\r\n#hr-content .btn-select-all [type=\"checkbox\"]+span:not(.lever) {\r\n    font-size: 12px !important;\r\n}\r\n\r\n#hr-content .btn-select-all {\r\n    position: absolute;\r\n    top: -14px;\r\n    left: 5px;\r\n    /*right: 5px;*/\r\n}\r\n\r\n.inner-container th .detail {\r\n    color: red;\r\n    font-size: 12px;\r\n    text-transform: none;\r\n    font-weight: normal;\r\n    line-height: 14px;\r\n}\r\n.red-text {\r\n    color: red !important;\r\n}\r\n.inner-container #table-total {\r\n    height: 40px;\r\n    margin-bottom: 10px;\r\n}\r\n#content-assign_days .title{\r\n    text-align: right;\r\n    line-height: 30px;\r\n}\r\n#content-assign_days{\r\n    margin-top: 25px;\r\n}\r\n.inner-container .dropdown-content li>a, .inner-container .dropdown-content li>span {\r\n    font-size: 14px;\r\n    text-transform: none;\r\n    padding: 10px 12px;\r\n    font-weight: normal;\r\n}\r\n.inner-container .th-bulk-action .dropdown-trigger {\r\n    font-size: 12px !important;\r\n    padding: 0 5px !important;\r\n}\r\n.inner-container .th-bulk-action {\r\n    position: relative;\r\n}\r\n.inner-container .inp-assign-disable-expired {\r\n    border: 2px solid #bf4848 !important;\r\n    height: 30px !important;\r\n    margin-bottom: 0px !important;\r\n    padding-bottom: 0px !important;\r\n    text-align: center;\r\n    color: #9e9e9e;\r\n    background-color: #eee !important;\r\n    font-size: 14px !important;\r\n    max-width: 60px;\r\n    min-width: 60px;\r\n}\r\n.inner-container .inp-assign-disable {\r\n    border: 2px solid #d1d1d1 !important;\r\n    height: 30px !important;\r\n    margin-bottom: 0px !important;\r\n    padding-bottom: 0px !important;\r\n    text-align: center;\r\n    color: #9e9e9e;\r\n    background-color: #eee !important;\r\n    font-size: 14px !important;\r\n    max-width: 60px;\r\n    min-width: 60px;\r\n}\r\n.inner-container .inp-assign, .modal-inp-assign {\r\n    border: 2px solid #2b988e !important;\r\n    height: 30px !important;\r\n    margin-bottom: 0px !important;\r\n    padding-bottom: 0px !important;\r\n    text-align: center;\r\n    font-size: 14px !important;\r\n    max-width: 60px;\r\n    min-width: 60px;\r\n}\r\n.inner-container th {\r\n    font-size: 12px;\r\n}\r\n.inner-container .btn-delete, .inner-container .btn-check {\r\n    padding-right: 8px;\r\n    padding-left: 8px;\r\n}\r\n.inner-container .btn-view-calendar .material-icons {\r\n    color: #000;\r\n    margin-left: 8px;\r\n    font-size: 21px;\r\n    line-height: 38px;\r\n}\r\n.inner-container .btn-view-calendar {\r\n    float: right;\r\n    margin-left: 5px;\r\n    font-size: 13px;\r\n    text-transform: none;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n}\r\n.inner-container .btn-export .material-icons {\r\n    color: #000;\r\n    margin-left: 8px;\r\n    font-size: 20px;\r\n    line-height: 38px;\r\n}\r\n.inner-container .btn-export {\r\n    float: right;\r\n    margin-left: 5px;\r\n    font-size: 13px;\r\n    text-transform: none;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n}\r\n.inner-container .image-circle i {\r\n    font-size: 36px;\r\n    margin-left: auto;\r\n}\r\n.inner-container .th-view, .inner-container .th-change {\r\n    max-width: 70px;\r\n}\r\n.inner-container .th-status {\r\n    max-width: 100px;\r\n    min-width: 100px;\r\n}\r\n.inner-container #main-content {\r\n    padding-top: 0px;\r\n    position: relative;\r\n}\r\n.inner-container #top-content {\r\n    border-bottom: 0px dashed #ece7e7;\r\n    margin-bottom: 25px;\r\n}\r\n.inner-container #main-btn {\r\n    /*border-bottom: 2px dashed #ece7e7;\r\n    padding-bottom: 18px;*/\r\n    position: absolute;\r\n    top: -90px;\r\n    right: 25px;\r\n}\r\n#table-leave-summary .text-center {\r\n    text-align: center;\r\n}\r\n#table-leave-summary .text-left {\r\n    text-align: left;\r\n}\r\n.inner-container .td-photo {\r\n    height: 65px;\r\n    position: relative;\r\n    min-width: 56px;\r\n}\r\n.inner-container .image-circle {\r\n    width: 56px;\r\n    height: 56px;\r\n    position: absolute;\r\n    top: 4px;\r\n    left: 50%;\r\n    margin-left: -28px;\r\n}\r\n.inner-container .select-helper-text {\r\n    margin-top: -10px;\r\n}\r\n.inner-container #form-filter-request .filter-inputs.row{\r\n    border-bottom: 2px dashed #ece7e7;\r\n}\r\n.inner-container #form-filter-request {\r\n    padding: 0 20px;\r\n}\r\n.inner-container #btn-select-limit-row .input-field {\r\n    margin-bottom: 0px;\r\n}\r\n.inner-container .input-field {\r\n    margin-top: 0px;\r\n    margin-bottom: 1rem;\r\n}\r\n.inner-container .select-wrapper .caret {\r\n    fill: #27766f;\r\n}\r\n.inner-container .filter-input-field.select .col {\r\n    border: 2px solid #2b988e;\r\n    border-radius: 11px;\r\n}\r\n.inner-container .dropdown-content li {\r\n    min-height: auto;\r\n}\r\n.inner-container .dropdown-content li>a, .inner-container .dropdown-content li>span {\r\n    line-height: 20px;\r\n    padding: 10px 16px;\r\n}\r\n.inner-container .input-field>label, .inner-container .input-field>input[type=date]:not(.browser-default)+label {\r\n    color: #27766f;\r\n}\r\n.inner-container input[type=text]:not(.browser-default):not(.inp-assign):not(.inp-assign-disable):not(.select-dropdown):not(.inp-assign-disable-expired), .inner-container input[type=date]:not(.browser-default), input[type=text]:not(.modal-inp-assign){\r\n    font-size: 14px;\r\n    border-bottom: 2px solid #2b988e;\r\n    color: #26a69a;\r\n}\r\n.inner-container [type=\"checkbox\"]+span:not(.lever) {\r\n    height: 22px;\r\n    line-height: 22px;\r\n    font-size: 14px;\r\n}\r\n.inner-container .select-wrapper input.select-dropdown {\r\n    font-size: 14px;\r\n    border-bottom: 0px solid red !important;\r\n    margin-bottom: 0px;\r\n    color: #26a69a;\r\n}\r\n.inner-container .grid-container, .inner-container .filter-inputs {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto auto;\r\n    grid-gap: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
